import { i18n } from 'i18n';
import * as activePoursPageConstants from './ActivePoursPage/constants';
import * as breakingSchedulesPageConstants from './BreakingSchedulePage/constants';

export interface QAQCAreaPageParams {
  entityId: string;
}

export const BASE_PATH = '/qaqc/dashboard';
export const ROUTE_PATH = `${BASE_PATH}/*`;
export const TITLE = i18n._('QAQC Area');

export const ACTIVE_POURS_ROUTE_PATH = BASE_PATH + activePoursPageConstants.ROUTE_PATH;
export const ACTIVE_POURS_TITLE = activePoursPageConstants.TITLE;

export const BREAKING_SCHEDULES_ROUTE_PATH = BASE_PATH + breakingSchedulesPageConstants.ROUTE_PATH;
export const BREAKING_SCHEDULES_TITLE = breakingSchedulesPageConstants.TITLE;
